import React from 'react'

function Warrants() {
  return (
    <div>Warrants</div>
  )
}

export default Warrants